import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  paperContainer: {
    height: '100%',
  },
  messageContainer: {
    paddingBlock: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    height: 327,
  },
}))

export default useStyles
